const updatePropertyZonesTotal = (state, payload) => {
  state.total = payload
}

export default {
  updatePropertyZonesTotal,
}
